// packages/agent-kit/src/hooks/billing/useCreditBalance.ts
import useSWR, { BareFetcher } from 'swr';
import { billingService, isApiError } from '@dopomogai/api-client';
import type { UserCreditsResponse } from '@dopomogai/types';
import { AgentKitError } from '../types';

export const useCreditBalance = (enabled = true) => {
  const swrKey = enabled ? '/users/me/credits' : null;

  const fetcher: BareFetcher<UserCreditsResponse> = async () => {
    const res = await billingService.getAccountCredits();
    if (isApiError(res)) {
      throw new AgentKitError('Failed to fetch account credits', res);
    }
    return res;
  };

  const { data, error, isLoading, mutate } = useSWR<UserCreditsResponse, AgentKitError>(
    swrKey,
    fetcher,
    // --- ADD THIS ---
    {
      revalidateOnFocus: false,
    }
  );

  return {
    balance: data?.balance ?? null,
    isLoading,
    error,
    mutate,
  };
};